import { AddToCartPage } from '../api/AddToCartPageRepositoryInterface';
import { AddToCartPageSectionTypes } from '../typings/AddToCartPageSection';
import { ATCPageSteps } from '../typings/AddToCartPageStep';

export function mapAddToCartToSteps(
  addToCartPage: AddToCartPage | null,
  isAddedAsSubscription: boolean = false,
  isBusinessCustomer: boolean = false,
  isCoolblueApp: boolean = false
): ATCPageSteps {
  if (addToCartPage === null) {
    return [];
  }

  const steps: ATCPageSteps = [];
  let insuranceIndex = -1;
  const hasInsuranceSection = addToCartPage.sections.reduce((check, section, index) => {
    if (section.__typename === AddToCartPageSectionTypes.INSURANCE_SECTION) {
      insuranceIndex = index;

      return true;
    }

    return check;
  }, false);

  if (
    !isCoolblueApp &&
    addToCartPage.sections.length > 1 &&
    addToCartPage.hasMultiStep &&
    hasInsuranceSection &&
    !isAddedAsSubscription &&
    !isBusinessCustomer
  ) {
    const sections = [...addToCartPage.sections];
    const stepTwo = sections.splice(insuranceIndex, 1);
    steps.push(sections);
    steps.push([...stepTwo]);

    return steps;
  }

  steps.push(addToCartPage.sections);

  return steps;
}
